import React from "react";
import { Redirect, Route, Switch } from "react-router";
import ContextProvider from "../Context/Context";
import LoginComponent from "../Login/LoginComponent";
import Register from "../Register/Register";
import Homepage from "./Homepage/Homepage";
import "./main-page.style.scss";
export default function MainPage() {
  return (
    <div className="main-page-container">
      <Switch>
        <Route path="/login" component={LoginComponent} />
        <Route path="/register" component={Register} />
        <Route
          path="/home"
          render={() => (
            <ContextProvider>
              <Homepage />
            </ContextProvider>
          )}
        />
        <Redirect to="/home" />
      </Switch>
    </div>
  );
}
